import { formatPatchingBillingMonthLabel } from './patchingBillingPdfSection';

function monthIndexFromParts(year: number, month1Based: number): number {
  return year * 12 + (month1Based - 1);
}

function monthIndexFromDate(date: Date): number {
  return date.getUTCFullYear() * 12 + date.getUTCMonth();
}

function monthStringFromIndex(index: number): string {
  const year = Math.floor(index / 12);
  const month1 = (index % 12) + 1;
  return `${year}-${String(month1).padStart(2, '0')}`;
}

export function getPatchingQuarterCycleForDate(
  engagementStartDate: string | Date,
  referenceDate: Date = new Date()
): { cycleStartMonth: string; cycleEndMonth: string; billingMonthYm: string } | null {
  const start =
    typeof engagementStartDate === 'string'
      ? new Date(engagementStartDate)
      : engagementStartDate;
  const startIndex = monthIndexFromDate(start);
  const targetIndex = monthIndexFromParts(
    referenceDate.getFullYear(),
    referenceDate.getMonth() + 1
  );
  if (targetIndex < startIndex) {
    return null;
  }

  const monthsSinceStart = targetIndex - startIndex;
  const cycleOffset = Math.floor(monthsSinceStart / 3) * 3;
  const cycleStartIndex = startIndex + cycleOffset;
  const cycleEndIndex = cycleStartIndex + 2;

  return {
    cycleStartMonth: monthStringFromIndex(cycleStartIndex),
    cycleEndMonth: monthStringFromIndex(cycleEndIndex),
    billingMonthYm: monthStringFromIndex(cycleEndIndex)
  };
}

export function getPatchingQuarterBillingMonthLabel(
  engagementStartDate: string | Date,
  referenceDate?: Date
): string | null {
  const cycle = getPatchingQuarterCycleForDate(engagementStartDate, referenceDate);
  if (!cycle) {
    return null;
  }
  return formatPatchingBillingMonthLabel(cycle.billingMonthYm);
}
